export function cn(...parts: Array<string | false | undefined | null>) {
  return parts.filter(Boolean).join(" ")
}
